import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

function Testimonials() {
  const [ready, setReady] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    const timeout = setTimeout(() => setReady(true), 100);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (ready && swiperRef.current?.swiper) {
      swiperRef.current.swiper.update();
    }
  }, [ready]);

  const testimonialList = [
    {
      text: "Microcode tripled our business engagement. Amazing!",
      name: "Anita S.",
      position: "Senior Consultant"
    },
    {
      text: "The web design exceeded all my expectations.",
      name: "Rakesh M.",
      position: "Marketing Manager"
    },
    {
      text: "The app is smooth and intuitive. Great job!",
      name: "Vikram R.",
      position: "Marketing Manager"
    },
    {
      text: "One of the best online marketing companies in India.",
      name: "Deepika J.",
      position: "Marketing Manager"
    }
  ];

  // Split into groups of 2
  const groupedTestimonials = [];
  for (let i = 0; i < testimonialList.length; i += 2) {
    groupedTestimonials.push(testimonialList.slice(i, i + 2));
  }

  return (
    <div
      className="testimonial-style-two-area bg-dark default-padding text-light bg-cover"
      style={{ backgroundImage: "url(static/img/shape/5.webp)" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="testimonial-two-info">
              <div className="icon">
                <img title='Microcode Software' src="static/img/quote.png" alt="Quote" />
              </div>
              <h2 className="split-text">Words from Our Valued Clients</h2>
              <div className="review-card">
                <h6>Excellent 5,120+ Reviews</h6>
                <div className="d-flex">
                  <div className="icon">
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                    <i className="fas fa-star" />
                  </div>
                  <span>4.8/5</span>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8 pl-60 pl-md-15 pl-xs-15">
            {ready && (
              <Swiper
                ref={swiperRef}
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                slidesPerView={1}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                pagination={{ clickable: true }}
                loop={true}
                className="testimonial-style-two-carousel"
              >
                {groupedTestimonials.map((group, index) => (
                  <SwiperSlide key={index}>
                    <div className="row">
                      {group.map((item, subIndex) => (
                        <div className="col-md-6" key={subIndex}>
                          <div className="testimonial-style-two mb-4">
                            <div className="item">
                              <div className="text-info">
                                <p>"{item.text}"</p>
                              </div>
                              <div className="content">
                                <div className="info">
                                  <h4>{item.name}</h4>
                                  <span>{item.position}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
